export default "__VITE_ASSET__234e8546__"